export default "__VITE_ASSET__BOb7XY01__"